<template>
  <el-select
    :clearable="clearable"
    :disabled="disabled"
    filterable
    :value="value"
    @change="changeHandle"
  >
    <el-option
      v-for="(item, index) in beansList"
      :key="index"
      :value="item.value"
      :label="item.name"
    ></el-option>
  </el-select>
</template>

<script>
import beansMixin from './mixin.js';

export default {
  name: 'beans-select',
  props: {
    size: String,
    value: Number,
    disabled: Boolean,
    clearable: {
      type: Boolean,
      default: true,
    },
  },
  mixins: [beansMixin],
  methods: {
    changeHandle(val) {
      this.$emit('input', val);
      this.$emit('change', val);
    },
  },
};
</script>

